import { render, staticRenderFns } from "./Stars.vue?vue&type=template&id=5147e0a8&scoped=true&"
import script from "./Stars.vue?vue&type=script&lang=js&"
export * from "./Stars.vue?vue&type=script&lang=js&"
import style0 from "./Stars.vue?vue&type=style&index=0&id=5147e0a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5147e0a8",
  null
  
)

export default component.exports